import http_config from '../../common/config/http_config';
import axiosInstance from '../../common/helper/axiosInterceptor';

export const onUpgradeStudents = (payload: any): Promise<unknown> => {
  return axiosInstance.post(http_config.BASE_URL + '/upgrade-student', payload);
};
